module.exports = __webpack_public_path__ + "static/media/clockDarkMode.c602d8d3.svg";